import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const CloseIcon = React.memo(function CloseIcon(props: TCloseIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Close" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 18.0555C14.5899 18.0555 17.5 15.1454 17.5 11.5555C17.5 7.96569 14.5899 5.05554 11 5.05554C7.41015 5.05554 4.5 7.96569 4.5 11.5555C4.5 15.1454 7.41015 18.0555 11 18.0555ZM11 19.5555C15.4183 19.5555 19 15.9738 19 11.5555C19 7.13726 15.4183 3.55554 11 3.55554C6.58172 3.55554 3 7.13726 3 11.5555C3 15.9738 6.58172 19.5555 11 19.5555Z"
            />
            <path d="M12.0607 11.5557L13.8287 9.78777C14.0239 9.59251 14.0239 9.27593 13.8287 9.08066L13.4751 8.72711C13.2798 8.53185 12.9633 8.53185 12.768 8.72711L11 10.4951L9.23208 8.72713C9.03682 8.53187 8.72024 8.53187 8.52498 8.72713L8.17142 9.08068C7.97616 9.27594 7.97616 9.59253 8.17142 9.78779L9.93937 11.5557L8.1718 13.3233C7.97654 13.5186 7.97654 13.8351 8.1718 14.0304L8.52535 14.384C8.72061 14.5792 9.0372 14.5792 9.23246 14.384L11 12.6164L12.7676 14.384C12.9629 14.5792 13.2795 14.5792 13.4747 14.384L13.8283 14.0304C14.0235 13.8352 14.0235 13.5186 13.8283 13.3233L12.0607 11.5557Z" />
        </IconBase>
    );
});

export default CloseIcon;

// #region Types

export type TCloseIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <CloseIcon /> : { ...IconBaseExample, render: CloseIcon };

// #endregion
